import type {AgentMetadata} from "../types/chatTypes";

export const CHAT_UNAVAILABLE_DATABAG_TOOLTIP =
    "This feature is not available in the selected databag";

export const DASHGEN_APP_NAME = "dashgen";

export function isDashgenAppName(appName: string | undefined): boolean {
    return appName?.toLowerCase() === DASHGEN_APP_NAME;
}

export function isAgentEnabledForDatabag(
    agent: AgentMetadata,
    databagId: number,
): boolean {
    return agent.active_databags.includes(databagId);
}

/** True when at least one agent from metadata is enabled for the databag. */
export function hasAgentForDatabag(
    agents: AgentMetadata[] | undefined,
    databagId: number | undefined,
): boolean {
    if (!agents?.length || databagId == null) {
        return false;
    }
    return agents.some((agent) => isAgentEnabledForDatabag(agent, databagId));
}
